import { useEffect, useState } from "react";

import {
  Container,
  FormControlLabel,
  Unstable_Grid2 as Grid,
  Box,
  Radio,
  RadioGroup,
  Typography,
  Button,
  CircularProgress,
  Checkbox,
  Alert,
  styled,
} from "@mui/material";

// * form
import { useForm } from "react-hook-form";

// * services
import { getBanks, postPaymentTokenization } from "../services/payments";

// components
import CardList from "./CardList";
import BankForm from "./BankForm";
import SharedModal from "./shared/SharedModal";
import RequiestStatusModal from "./modals/RequiestStatusModal";
import { emailRegex, pagesUrl, redirectPage } from "../utils/misc";

// hooks
import { useDeviceId } from "../hooks/useDeviceId";
import SignaturesListModal from "./modals/SignaturesListModal";
import { useAuthToken } from "../hooks/useAuthToken";
import { useTranslation } from "react-i18next";
import { useQuery } from "hooks/useQuery";
import {
  putTokenizationTransaction,
  showTokenizationTransaction,
} from "services/tokenizationTransaction";
import Error from "pages/PaymentLink/components/Error";
import { AthleticLogo, IconCheckCircleOutlined } from "assets/icons/config";
import { LogoBody } from "assets/logos";
import { TokenizationCertificate } from "./TokenizationCertificate";

const Main = styled(Container)`
  padding: 30px;
  .customerInfo {
    background: #f7f7f7;
    border-radius: 10px;
  }
`;

const errorList = {
  130: "Error en el método de pago",
  109: "Error en datos del customer",
  110: "Error en datos del customer",
  111: "Error en datos del customer",
  112: "Error en datos del customer",
  113: "Error en datos del customer",
  114: "Error en datos del customer",
  119: "La tarjeta es requerida",
  120: "Tarjeta no encontrada",
  121: "La tarjeta es invalida",
  122: "Datos de la tarjeta incorrectos",
  129: "Limite de tarjetas permitidas excedido",
  140: "Titular de la tarjeta invalido",
};

export default function TokenizationTransaction({ setCurrentBrand }) {
  const query = useQuery();
  const reference = query.get("ref");
  const currentBrand = query.get("b");

  const [option, setOption] = useState("card");

  // credit card
  const [cardName, setCardName] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [cvc, setCvc] = useState("");
  const [expiry, setExpiry] = useState("");
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [currentStatus, setCurrentStatus] = useState("");
  const [isControlError, setIsControlError] = useState(false);
  const [errorCollection, setErrorCollection] = useState([]);
  const [translatedCollection, setTranslatedCollection] = useState([]);
  const [emailError, setEmailError] = useState(null);
  const [serverResponse, setServerResponse] = useState([]);
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [openCertificationModal, setOpenCertificationModal] = useState(false);
  const [
    showPaymentMethodValidationModal,
    setShowPaymentMethodValidationModal,
  ] = useState(false);
  const [formData, setFormData] = useState({});
  const [messageError, setMessageError] = useState("");
  const [descriptionError, setDescriptionError] = useState(null);
  const [bankList, setBankList] = useState([]);

  // *  bank form
  const [selectedAccount, setSelectedAccount] = useState(false);

  // *  card form
  const [selectedCard, setSelectedCard] = useState(false);

  const [disableSubmit, setDisableSubmit] = useState(true);

  const [cardErrors, setCardErrors] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm();

  const { t } = useTranslation();

  const { getDeviceId } = useDeviceId();

  const { getAuthToken } = useAuthToken();

  useEffect(() => {
    reset("");
  }, [option, reset]);

  useEffect(() => {
    if (errorCollection.length > 0) {
      const errors = [];
      errorCollection?.forEach((item) => {
        if (item.message.message) {
          errors.push({
            message: errorList[item.message.message.replace(/\D/g, "")]
              ? errorList[item.message.message.replace(/\D/g, "")]
              : "No se pudo validar el método de pago",
          });
        } else {
          errors.push({
            message: item.message,
          });
        }
      });
      setTranslatedCollection(errors);
    }
  }, [errorCollection]);

  useEffect(() => {
    setDisableSubmit(
      (cardErrors.length > 0 ||
        cardNumber.length === 0 ||
        cvc.length === 0 ||
        expiry.length === 0) &&
        option === "card"
    );
  }, [cardErrors, option]);

  const handleChange = (event) => {
    setOption(event.target.value);
  };

  const pushError = (key, newError) => {
    if (!cardErrors.includes(key) && newError) {
      setCardErrors([...cardErrors, key]);
    } else {
      const filteredErrors = cardErrors.filter((err) => err !== key);
      setCardErrors(filteredErrors);
    }
  };

  const fetch = async () => {
    try {
      const { data } = await showTokenizationTransaction(reference);
      let msg =
        "Parece que estamos experimentando problemas, por favor recarga la pagina. Si el problema persiste comunícate con nuestra linea de servicio al cliente.";

      if (data?.data?.uuid) {
        setMessageError("");
        setDescriptionError(null);
        return;
      }

      if (data?.data?.hasPreviousTokenization) {
        setMessageError("Ya tienes un método de pago registrado");
        setDescriptionError(data?.data?.message);
        return;
      }

      msg = data?.message?.length ? data?.message[0]?.message : msg;

      setMessageError("Se produjo un error");
      setDescriptionError(msg);
    } catch (err) {
      console.error(err);
      setMessageError("Se produjo un error");
      setDescriptionError("Se ha producido un error, comunícate con un asesor");
    }
  };

  useEffect(() => {
    if (currentBrand) {
      setCurrentBrand(currentBrand);

      localStorage.setItem("current_brand", currentBrand);
      (async () => {
        await getAuthToken();

        if (reference) {
          fetch(reference);
        }
      })();
    }
  }, [reference, currentBrand]);

  useEffect(() => {
    if (option === "bank") {
      (async () => {
        const { data } = await getBanks(1);

        if (data?.data?.items) {
          setBankList(data?.data?.items);
        }
      })();
    }
  }, [option]);

  const onFormSubmit = (data) => {
    if (option === "card") {
      setShowPaymentMethodValidationModal(true); // Abrimos el modal
      setFormData(data); // Guardamos los datos para enviarlos tras confirmar
    } else {
      onSubmit(data);
    }
  };

  const handleConfirmCreditCard = () => {
    onSubmit(formData);
    setShowPaymentMethodValidationModal(false);
  };

  const onSubmit = async (data) => {
    if (!localStorage.getItem("access_token_bt")) {
      getAuthToken();
      return;
    }

    let submitData = {
      reference,
    };

    // ! card payment
    if (option === "card") {
      submitData = {
        ...submitData,
        type: "credit_card",
        name: data.name,
        number_document: data.number_document,
        type_document: data.type_document,
      };
      const expladeExpiryCard = expiry.split("/");
      submitData["name"] = cardName;
      submitData["expiration_month"] = expladeExpiryCard[0].replace(/\s/g, "");
      submitData["security_code"] = cvc;
      submitData["expiration_year"] =
        "20" + expladeExpiryCard[1].replace(/\s/g, "");
      submitData["card_number"] = cardNumber;

      // ! bank payment
    } else if (option === "bank") {
      if (!emailRegex.test(data.email)) {
        setEmailError("Correo invalido");
        return;
      }

      submitData = {
        ...submitData,
        banks_id: data.banks_id,
        account: data.account,
        account_type: data.account_type,
        type: "bank_account",
        name: `${data?.name?.trim()} ${data?.first_last_name?.trim()} ${data?.second_last_name?.trim()}`
          .toUpperCase()
          .trim(),
        last_name: `${data?.first_last_name?.trim()}`.toUpperCase(),
        number_document: data.number_document,
        type_document: data.type_document,
        mail: data.email,
      };
    }

    submitData["device_id"] = getDeviceId();

    setIsLoading(true);
    try {
      const response = await putTokenizationTransaction(submitData);

      if (response?.data?.data?.uuid) {
        setOpenSuccessModal(true);
      } else if (response?.data?.data?.hasPreviousTokenization) {
        setMessageError("Ya tienes un método de pago registrado");
        setDescriptionError(response?.data?.data?.message);
      } else {
        const message = response?.data?.message?.length
          ? response?.data?.message[0]?.message
          : t("Tokenization.Rejected");

        setCurrentStatus(message);
        setShowStatusModal(true);
        setIsControlError(true);
      }
    } catch (err) {
      if (err?.response.status === 422) {
        setCurrentStatus(t("Tokenization.Rejected"));
        setIsControlError(true);
      } else {
        setCurrentStatus(
          "Hubo un error al procesar tu solicitud, intenta nuevamente"
        );
        setIsControlError(false);
      }

      setShowStatusModal(true);
    } finally {
      setIsLoading(false);
    }
  };

  const onError = () => {};

  if (messageError) {
    return <Error message={messageError} description={descriptionError} />;
  }

  return (
    <>
      <Main
        style={{
          maxWidth: 400,
          minHeight: "100vh",
          border: "1px solid #ccc",
          boxShadow: "0px 0px 10px 1px #ccc",
        }}
      >
        <form onSubmit={handleSubmit(onFormSubmit, onError)}>
          <Grid container spacing={2}>
            <Grid size={12}>
              <Box
                display={"flex"}
                justifyContent={"center"}
                style={{ margin: "auto" }}
              >
                {["1", "3"].includes(currentBrand) ? (
                  <LogoBody />
                ) : (
                  <AthleticLogo />
                )}
              </Box>
            </Grid>
            <Grid size={12}>
              <Box display={"flex"} justifyContent={"center"}>
                <Typography
                  variant={"h5"}
                  style={{ fontSize: 17 }}
                  color={"primary"}
                >
                  {"Inscripción de Método de Pago"}
                </Typography>
              </Box>
            </Grid>

            <Grid size={12}>
              <Box display={"flex"} justifyContent={"center"}>
                <RadioGroup onChange={handleChange} value={option} row>
                  <FormControlLabel
                    value="card"
                    control={<Radio size="small" />}
                    label={
                      <Typography style={{ fontSize: 12 }}>
                        {"CRÉDITO"}
                      </Typography>
                    }
                  />

                  {currentBrand !== "3" && (
                    <FormControlLabel
                      value="bank"
                      control={<Radio size="small" />}
                      label={
                        <Typography style={{ fontSize: 12 }}>
                          {"AHORROS/CORRIENTE"}
                        </Typography>
                      }
                    />
                  )}
                </RadioGroup>
              </Box>
            </Grid>
            <Grid size={12}>
              {option === "card" ? (
                <CardList
                  data={[]}
                  control={control}
                  cvc={cvc}
                  setCvc={setCvc}
                  expiry={expiry}
                  setExpiry={setExpiry}
                  cardNumber={cardNumber}
                  setCardNumber={setCardNumber}
                  setCardName={setCardName}
                  setSelectedCard={setSelectedCard}
                  selectedCard={selectedCard}
                  reset={reset}
                  pushError={pushError}
                  errors={errors}
                />
              ) : (
                <BankForm
                  data={[]}
                  control={control}
                  bankList={bankList}
                  setSelectedAccount={setSelectedAccount}
                  selectedAccount={selectedAccount}
                  reset={reset}
                  errors={errors}
                  emailError={emailError}
                  setEmailError={setEmailError}
                />
              )}
            </Grid>
            <Grid size={12}>
              <Box display={"flex"} justifyContent={"center"}>
                <FormControlLabel
                  style={{ maxWidth: 400 }}
                  label={
                    <Typography
                      style={{
                        fontSize: 13,
                        fontFamily: "Gotham Medium",
                        textDecoration: "underline",
                      }}
                    >
                      <b>
                        Estoy aceptando el débito mensual de este medio de pago.
                      </b>
                    </Typography>
                  }
                  control={
                    <Checkbox size="small" checked={true} name="checked" />
                  }
                />
              </Box>
            </Grid>
            {option === "card" && (
              <Grid size={12}>
                <Alert severity="warning" style={{ fontSize: "0.8rem" }}>
                  Recuerda que no podrás inscribir una tarjeta débito o prepago,
                  solo podrás inscribir una tarjeta crédito o una cuenta
                  bancaria.
                </Alert>
              </Grid>
            )}
            <Grid size={12}>
              <Box display={"flex"} justifyContent={"center"} mt={1}>
                <Button
                  type="submit"
                  disabled={disableSubmit || isLoading}
                  variant="contained"
                  fullWidth
                  color="primary"
                  style={{ maxWidth: 400 }}
                >
                  {isLoading ? (
                    <CircularProgress size={30} color="primary" />
                  ) : (
                    <span>{"Guardar"}</span>
                  )}
                </Button>
              </Box>
            </Grid>

            <Grid size={12}>
              <Box display={"flex"} justifyContent={"center"}>
                <Typography style={{ fontSize: 13 }} align="center">
                  {"Todas las transacciones se realizan de forma segura."}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </form>

        {showStatusModal && (
          <SharedModal
            isOpen={showStatusModal}
            modalBody={
              <Box
                display={"flex-columns"}
                justifyContent={"center"}
                alignItems={"center"}
              >
                <Typography variant="h4" color={"primary"}>
                  {`Inscripción ${isControlError ? "Rechazada" : "Fallida"}!`}
                </Typography>
                <br />
                <span>{currentStatus}</span>
                <br />
                <br />
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  gap={2}
                >
                  <Button
                    onClick={() => setShowStatusModal(false)}
                    variant="contained"
                    color="primary"
                  >
                    {option === "card" || !isControlError
                      ? "Aceptar"
                      : "Corregir"}
                  </Button>
                  {option !== "card" && isControlError && (
                    <Button
                      onClick={() => {
                        setShowStatusModal(false);
                        setOpenCertificationModal(true);
                      }}
                      variant="contained"
                      color="primary"
                    >
                      Cargar certificado
                    </Button>
                  )}
                </Box>
              </Box>
            }
          />
        )}

        {openSuccessModal && (
          <SharedModal
            isOpen={openSuccessModal}
            modalBody={
              <Box
                display={"flex-columns"}
                justifyContent={"center"}
                alignItems={"center"}
              >
                <Typography variant="h4" color={"primary"}>
                  {"Inscripción Exitosa!"}
                </Typography>
                <br />
                <span>
                  Nos complace informarte que tu solicitud de inscripción al{" "}
                  <b>método de pago</b> ha sido procesada <b>exitosamente!</b>
                </span>
                <br />
                <br />
                <Box
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                >
                  <Button
                    onClick={() =>
                      window.location.replace(pagesUrl[currentBrand])
                    }
                    variant="contained"
                    color="primary"
                    endIcon={<IconCheckCircleOutlined color="#fff" />}
                  >
                    {"Aceptar"}
                  </Button>
                </Box>
              </Box>
            }
          />
        )}

        {showPaymentMethodValidationModal && (
          <SharedModal
            isOpen={showPaymentMethodValidationModal}
            modalBody={
              <Box
                display={"flex-columns"}
                justifyContent={"center"}
                alignItems={"center"}
              >
                <Typography variant="h4" color={"primary"}>
                  {"Validación Método de Pago"}
                </Typography>
                <br />
                <span>
                  Para verificar la validez de tu tarjeta y proteger tu
                  seguridad, realizaremos un cargo temporal de <b>$1 USD.</b>{" "}
                  Este monto será reembolsado automáticamente a tu tarjeta una
                  vez completada la validación.
                </span>
                <br />
                <br />
                <Box
                  display={"flex"}
                  alignItems={"between"}
                  justifyContent={"space-around"}
                >
                  <Button
                    onClick={() => setShowPaymentMethodValidationModal(false)}
                    variant="contained"
                    color="secondary"
                  >
                    {"Cancelar"}
                  </Button>
                  <Button
                    onClick={() => handleConfirmCreditCard()}
                    variant="contained"
                    color="primary"
                    endIcon={<IconCheckCircleOutlined color="#fff" />}
                  >
                    {"Aceptar"}
                  </Button>
                </Box>
              </Box>
            }
          />
        )}

        {openCertificationModal && (
          <SharedModal
            isOpen={openCertificationModal}
            modalBody={
              <TokenizationCertificate
                onCancel={() => setOpenCertificationModal(false)}
                reference={reference}
              />
            }
          />
        )}
      </Main>
    </>
  );
}
